module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('NbTank', {
    attrs: {
      "tank": _vm.tank
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.tank.name) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.tank.url) + "\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', [_vm._v("大文件上传")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-668c5a67"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/tank/Upload.vue
// module id = 997
// module chunks = 1